<template>
	<div v-bind:class="['form']">
		<h3>
			Login
			<router-link :to="loginSecondary">{{ loginSecondaryText }}</router-link>
		</h3>

		<!-- Username input -->
		<EmailDisplay
			v-if="authenticatedEmail"
			v-model="email"
			v-bind:error="emailError">
		</EmailDisplay>
		<EmailInput
			v-else
			v-model="email"
			v-bind:error="emailError"
			@next="initiateLogin">
		</EmailInput>

		<!-- Password input -->
		<PasswordInput
			v-if="authenticatedEmail"
			:autofocus="true"
			v-model="password"
			v-bind:error="passwordError"
			@next="login">
		</PasswordInput>

		<!-- Login button -->
		<button
			v-bind:class="{ disabled: authenticating }"
			v-on:click="loginAction">
			{{ loginActionText }}
		</button>
	</div>
</template>

<script>
import AuthForm from '.'

export default {
	name: 'login-form',
	extends: AuthForm,

	props: {
		logout: {
			type: Boolean
		}
	},

	mounted() {
    },

	methods: {
		loginAction() {
			if (this.authenticatedEmail)
				this.login()
			else
				this.initiateLogin()
		}
	},

	computed: {
		loginActionText() {
			return (this.authenticatedEmail) ? 'login' : 'next'
		},
		loginSecondaryText() {
			return (this.authenticatedEmail) ? 'forgot password?' : ''
		},
		loginSecondary() {
			return (this.authenticatedEmail) ? '/reset' : '/login'
		}
	}
}
</script>

<style scoped lang="scss">
@import "style.scss";
</style>
